import React from "react";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";
import { Layout, PageHeader } from "../../common/components";
import { RegisterPage, DataCreatePage, DataEditPage, ExtendPage } from "./page";
import { hasRights, rights } from "../../common/utils/role-right-helper";

const UserListHeader = (
  <PageHeader title="Registration" />
)

const Registration = ({ match }) => {
  if(!hasRights([rights.CanViewRegistration]))
    return (<Redirect to="/" />);

  return (
    <Layout PageHeader={UserListHeader}>
      <Switch>
        <Route exact path={`${match.url}`} component={RegisterPage} />
        <Route exact path={`${match.url}/:regid/create`} component={DataCreatePage} />
        <Route exact path={`${match.url}/:regid/edit`} component={DataEditPage} />
        <Route exact path={`${match.url}/:regid/extend`} component={ExtendPage} />
      </Switch>
    </Layout>
  );
}

Registration.propTypes = {
    match: PropTypes.shape({
        url: PropTypes.string,
      }),
};

Registration.defaultProps = {
    match: {
        url: "",
      },
};

export default withRouter(Registration);
